import { Box } from '@mui/material'

import { Spinner } from '@percent/lemonade'

export function FullPageSpinner() {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}
    >
      <Spinner size={8} />
    </Box>
  )
}
